export default {
  NONE: '',
  BASIC: 'Connect Domain + Wix Video',
  COMBO: 'Combo + Wix Video',
  PRO: 'Unlimited + Wix Video',
  VIP: 'VIP + Wix Video',
};



// WEBPACK FOOTER //
// ./src/shared/constants/premium-plans.js